import React from "react";
import UserProfile from "../../components/UserProfile/UserProfile";

export default function DashboardHeader({profileData}){
    return(
     <>
      <div className="lg:hidden sticky top-0 left-0 w-full h-[70px] bg-white shadow-md flex items-center px-2 z-50">
             <UserProfile
               NotificationBlock={true}
               width={'small'}
               mailId={profileData?.DoctorProfile?.DoctorName}
               imgUrl={profileData?.DoctorProfile?.coverPic}
             />
           </div>
           <div className="hidden xl:block h-28 bg-blue-700 rounded-br-2xl rounded-bl-2xl relative">
             <img
               className="w-full h-full object-cover rounded-br-2xl rounded-bl-2xl"
               src={require('../../Assets/img/odds/Graphic Side.jpg')}
             />
             <h1 className="text-white highlightText absolute top-1/2 left-6 -translate-y-1/2 capitalize">
               Welcome, Dr. {profileData?.DoctorProfile?.DoctorName}
               <span className="subHeadingText  text-white capitalize pl-2">
                  {profileData?.DoctorProfile?.specialization?.name}
              </span>
             </h1>
               
           </div>
     </>
    )
}